export const emailRegex = /^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/;
export const NUMBER_ONLY_REGEX: RegExp = /^-?\d* {0,1}\d+$/;
export const NUMBER_WITH_DECIMAL_REGEX: RegExp =
  /^[+-]?((\d+(\.\d*)?)|(\.\d+))$/;
